import {CONSTANTS} from "@k/js/meta_data";
import {EventVerteiler} from "@k/global/eventVerteiler";

export default class TextEditWrapper{
    private static isActive  = false;
    private static timerId = 0;
    private static value  = "";
    private static changeHandler : (v:string)=>void;

    static setChangeHandler(func) {
        TextEditWrapper.changeHandler = func;
    }

    static sendChange() {
        TextEditWrapper.isActive = false;
        TextEditWrapper.changeHandler(TextEditWrapper.value.toString());
    }

    static addChange(value) {
         if (TextEditWrapper.isActive) {
            clearTimeout(TextEditWrapper.timerId);
         }
         TextEditWrapper.isActive = true;
         TextEditWrapper.value = value;
         TextEditWrapper.timerId = setTimeout(function () {
            TextEditWrapper.sendChange();
         }, CONSTANTS.INPUT_PROCESSING_DELAY) as unknown as number;
    }
    static cancel() {
        clearTimeout(TextEditWrapper.timerId);
        TextEditWrapper.isActive = false;
        TextEditWrapper.value = "";

    }
}